import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { Inspector } from '../types/Inspector';

type QueryRecord = Record<string, string | number | boolean | null | undefined>;

const appendParams = (target: URLSearchParams, source: URLSearchParams | QueryRecord) => {
  if (source instanceof URLSearchParams) {
    source.forEach((value, key) => {
      target.append(key, value);
    });
    return;
  }
  Object.entries(source).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      return;
    }
    target.append(key, String(value));
  });
};

const buildSortParams = (sort?: string | string[]) => {
  if (!sort) return '';
  if (Array.isArray(sort)) {
    return sort.filter(Boolean).map((s) => '&sort=' + encodeURIComponent(s)).join('');
  }
  return '&sort=' + encodeURIComponent(sort);
};

export const listInspectors = (page = 0, size = 10, sort?: string | string[], query?: string): Promise<Page<Inspector>> => {
  const sortQuery = buildSortParams(sort);
  const filterQuery = query ? '&' + query : '';
  return apiFetch('/inspectors?page=' + page + '&size=' + size + sortQuery + filterQuery);
};

export const listInspectorsAll = (
  query?: string | URLSearchParams | QueryRecord,
  options: { includeInactive?: boolean } = {},
): Promise<Inspector[]> => {
  const params = new URLSearchParams();
  if (!options.includeInactive) {
    params.set('account.enabled.equals', 'true');
  }
  if (query) {
    if (typeof query === 'string') {
      appendParams(params, new URLSearchParams(query));
    } else {
      appendParams(params, query);
    }
  }
  const queryString = params.toString();
  return apiFetch('/inspectors/all' + (queryString ? '?' + queryString : ''));
};

export const getInspector = (id: number): Promise<Inspector> => apiFetch('/inspectors/' + id);
export const createInspector = (data: any): Promise<Inspector> =>
  apiFetch('/inspectors', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateInspector = (id: number, data: any): Promise<Inspector> =>
  apiFetch('/inspectors/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteInspector = (id: number): Promise<void> =>
  apiFetch('/inspectors/' + id, { method: 'DELETE' });
export const updateInspectorStatus = (id: number, enabled: boolean): Promise<void> =>
  apiFetch('/inspectors/' + id + '/status?enabled=' + (enabled ? 'true' : 'false'), { method: 'PUT' });
export const updateInspectorAccreditationValidator = (id: number, enabled: boolean): Promise<void> =>
  apiFetch('/inspectors/' + id + '/accreditation-validator?enabled=' + (enabled ? 'true' : 'false'), { method: 'PUT' });
